import { ArrowUp, Eye, EyeClosed } from "lucide-react";
import { useState } from "react";
import Typography from "../Typography/Typography";
import Button from "../Button/Button";

export default function Input({
  width = "full", // full, fit
  type = "text",
  name = "",
  title = "",
  placeholder,
  onChange,
  onSubmit,
  value = "",
  outlineColor = "gray-200",
}) {
  const [showPassword, setShowPassword] = useState(false);

  // Handler for the Enter key detection
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) {
      e.preventDefault();
      onSubmit(value);  // <-- Pass the string, not the event
    }
  };

  // Handler for button click submit
  const handleButtonClick = () => {
    if (onSubmit) {
      onSubmit(value);  // <-- Pass the string, not the event
    }
  };

  return (
    <div className="w-full flex flex-col items-start gap-[12px]">
      {title && <Typography size="16" weight="md">{title}</Typography>}
      <div
        className={`font-rg rounded-[12px] relative w-${width} bg-white outline outline-2 outline-${outlineColor} hover:outline-[3px] hover:outline-accent-light focus-within:outline-[3px] focus-within:outline-accent-light p-px overflow-hidden transition-all duration-200 ease-in-out`}
      >
        <input
          name={name}
          value={value}
          className="w-full rounded-[11px] h-full px-[16px] md:px-[18px] py-[16px] md:py-[16px] outline outline-0 focus:outline-2 focus:outline-accent"
          onChange={onChange}
          onKeyDown={handleKeyDown}
          type={type === "password" && !showPassword ? "password" : "text"}
          placeholder={placeholder}
          autoComplete="on"
        />
        {type === "password" && (
          <div
            onClick={() => setShowPassword(!showPassword)}
            className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer"
          >
            {showPassword ? <Eye size="20" /> : <EyeClosed size="20" />}
          </div>
        )}
        {onSubmit && (
          <div className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer">
            <Button
              size="sm"
              onClick={handleButtonClick}
              type="bw"
              icon={<ArrowUp size={16} color="gray" />}
            />
          </div>
        )}
      </div>
    </div>
  );
}
